export default function NotFoundPage() {
  return (
    <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: "clamp(16px, 6vw, 32px)" }}>
      <section style={{ textAlign: "center", maxWidth: 480 }}>
        <h1 className="mono" style={{ letterSpacing: "0.18em", textTransform: "uppercase" }}>404</h1>
        <p className="small" style={{ textTransform: "none", color: "var(--muted)" }}>
          The requested path drifted into the ether. Use the navigation to return to safe ground.
        </p>
      </section>
    </main>
  )
}
